import request from '@godaddy/request';
import debug from './utils/diagnostics';
import * as json from './utils/json';
import storage from 'sessionstorage';
const cookie = require('koekiemonster')();
import URL from './utils/url';

// @deprecated
// We have moved on from `cookie-monster` as it is no longer maintained
// Polyfill to cookie-monster@0.1.1
// See: https://github.com/kahnjw/cookie-monster/compare/0.1.1...0.2.1
//
cookie.get = cookie.getItem;
cookie.set = cookie.setItem;
cookie.remove = cookie.removeItem;
cookie.clear = null;

export {
  request,
  storage,
  cookie,
  debug,
  json,
  URL
};
